import { ocApi } from './ocApi'

const API_USER = process.env.API_USER || 'testuser'
const API_PASS = process.env.API_PASS || 'testbtpeel748'

const basicAuth =
  'Basic ' + Buffer.from(`${API_USER}:${API_PASS}`).toString('base64')

export const blogApi = ocApi.injectEndpoints({
  endpoints: (build) => ({
    getBlogList: build.mutation({
      query: () => ({
        url: '/back/blog/list',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
      }),
    }),

    getOneBlogItem: build.mutation({
      query: (itemId) => ({
        url: '/back/blog/one',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
        body: { id: itemId },
      }),
    }),

    getBlogProduct: build.mutation({
      query: (productId) => ({
        url: '/back/blog/product',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: basicAuth,
        },
        body: { product_id: productId },
      }),
    }),
  }),
})

export const {
  useGetBlogListMutation,
  useGetOneBlogItemMutation,
  useGetBlogProductMutation,
} = blogApi
